export default __webpack_public_path__ + "static/media/PTB.400be42b.jpg";